import { Injectable } from '@angular/core';
import { ErrorTypes } from 'src/utils/declarations';
import { VALIDATION_RULES } from 'src/utils/enums';
import { ERROR_MESSAGES } from 'src/utils/helpers';

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  constructor() {}

  getErrorValidationMessage(
    formControlName: string,
    errors: [string, any][]
  ): string {
    switch (true) {
      case this.checkErrorType(errors, VALIDATION_RULES.REQUIRED):
        return ERROR_MESSAGES[VALIDATION_RULES.REQUIRED]();

      case this.checkErrorType(errors, VALIDATION_RULES.MINLENGTH):
        return ERROR_MESSAGES[VALIDATION_RULES.MINLENGTH]();

      case this.checkErrorType(errors, VALIDATION_RULES.MAXLENGTH):
        return ERROR_MESSAGES[VALIDATION_RULES.MAXLENGTH]();

      case this.checkErrorType(errors, VALIDATION_RULES.PATTERN):
        return ERROR_MESSAGES[VALIDATION_RULES.PATTERN](formControlName);

      default:
        return '';
    }
  }

  checkErrorType(errors: [string, any][], key: ErrorTypes) {
    return errors.some(([errorKey]) => errorKey === key);
  }

  getErrorMessage(errors: [string, any][], key: ErrorTypes) {
    return errors.find(([k, v]) => k === key)?.[1];
  }
}
